import React from 'react';

import { BUTTON__CONTENT_CLASS } from '../constants';
import type { OutlineButtonLinkProps } from './types';
import { buttonContentTextColor } from '../styles/base.styles';
import { buttonSize } from '../styles/buttonSizes.styles';
import * as styles from './OutlineButton.styles';

export const OutlineButtonLink = ({
  active,
  children,
  compact = false,
  fullWidth = false,
  textColorMode = 'brand',
  ...props
}: OutlineButtonLinkProps) => (
  <a
    css={[styles.outlineButtonLink, buttonSize(compact, fullWidth)]}
    data-is-active={active}
    {...props}
  >
    <div className={BUTTON__CONTENT_CLASS} css={buttonContentTextColor[textColorMode]}>
      {children}
    </div>
  </a>
);
